import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { formatCurrenctyWithoutSignal } from 'utils'
import { FIREBASE_EVENTS, STORE_STAGES } from 'app-constants'
import { STATICS } from 'statics'
import { setStage } from 'slices/drawer'
import { useFirebaseEvent } from 'hooks'
import { Button } from 'components/button'
import { Card } from './components/card'
import { PRODUCT_DESCRIPTION_TWO_LINES_HEIGHT } from '../../constants'
import './style.scss'

export function ProductDetail({ selectedProduct: product, handleAddToCart }) {
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [isExpandedDescription, setIsExpandedDescription] = useState(false)
  const [shouldShowButton, setShouldShowButton] = useState(false)
  const { sendEvent } = useFirebaseEvent()
  const descriptionRef = useRef()
  const { familyName: name, banner: image, description, minValue: minimumValue } = product || {}
  const dispatch = useDispatch()

  useEffect(() => {
    function handleShowExpandButton() {
      const descriptionElement = descriptionRef.current

      if (descriptionElement) {
        const isClamped = descriptionElement.scrollHeight > descriptionElement.clientHeight

        if (isClamped) setShouldShowButton(true)
      }
    }

    handleShowExpandButton()
  }, [])

  useEffect(() => {
    function handleExpandDescriptionText() {
      const descriptionElement = descriptionRef.current

      if (descriptionElement) {
        if (isExpandedDescription)
          descriptionElement.style.maxHeight = `${descriptionElement.scrollHeight}px`
        else descriptionElement.style.maxHeight = `${PRODUCT_DESCRIPTION_TWO_LINES_HEIGHT}px`
      }
    }

    handleExpandDescriptionText()
  }, [isExpandedDescription])

  useEffect(() => {
    function handleSelectFirstOption() {
      const firstOption = product?.options[0] || null

      setSelectedProduct(firstOption)
    }

    handleSelectFirstOption()
  }, [product])

  function handleExpandedClick() {
    setIsExpandedDescription(prevState => !prevState)
  }

  function handleClick() {
    const evenLabel = `${FIREBASE_EVENTS.SOFTBUNDLE_BUY_PRODUCT.label} ${name}`

    sendEvent({ ...FIREBASE_EVENTS.SOFTBUNDLE_BUY_PRODUCT, label: evenLabel })
    handleAddToCart(selectedProduct, name)
    dispatch(setStage(STORE_STAGES.CART))
  }

  function renderCards() {
    const options = product?.options

    return options.map((option, index) => (
      <Card
        setSelectedProduct={setSelectedProduct}
        selectedProduct={selectedProduct}
        product={option}
        key={option.id}
        index={index}
      />
    ))
  }

  function renderPrice() {
    const hasOnlyOneOption = product?.options.length <= 1

    if (hasOnlyOneOption) return null

    return (
      <span className='price'>
        A partir de R$ <span className='value'>{formatCurrenctyWithoutSignal(minimumValue)}</span> /
        mês
      </span>
    )
  }

  function renderExpandButton() {
    if (!shouldShowButton) return null

    return (
      <button type='button' onClick={handleExpandedClick} className='expand-button'>
        <STATICS.ARROW_DOWN />
      </button>
    )
  }

  return (
    <div className='container-detail'>
      <div className='container-image'>
        <img alt={`Imagem do produto ${name}`} src={image} className='image' />
      </div>
      <div className='container-info'>
        <span className='title'>{name}</span>
        {renderPrice()}
        <div className={`${isExpandedDescription ? 'expanded' : ''} container-description`}>
          <span ref={descriptionRef} className='description'>
            {description}
          </span>
          {renderExpandButton()}
        </div>
      </div>
      <div className='container-products'>
        <span className='title'>Selecione um plano</span>
        <div className='container-cards'>{renderCards()}</div>
      </div>
      <Button color='primary' className='button' onClick={handleClick}>
        Incluir no meu plano
      </Button>
    </div>
  )
}
